import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/Navigation.css';

function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  const handleNavClick = (section) => {
    if (!isHome) {
      navigate(`/#${section}`);
    }
  };

  const renderLink = (section, text) => {
    if (isHome) {
      return (
        <ScrollLink
          to={section}
          spy={true}
          smooth={true}
          offset={-80}
          duration={500}
        >
          {text}
        </ScrollLink>
      );
    }
    return (
      <ScrollLink
        to={section}
        onClick={() => handleNavClick(section)}
      >
        {text}
      </ScrollLink>
    );
  };

  return (
    <nav className="navigation">
      <ul className="nav-links">
        <li>{renderLink('image-processor', 'Design Tile')}</li>
        <li>{renderLink('pricing', 'Pricing')}</li>
        <li>{renderLink('gallery', 'Gallery')}</li>
        <li>{renderLink('faq', 'FAQ')}</li>
        <li>{renderLink('footer', 'Contact')}</li>
      </ul>
    </nav>
  );
}

export default Navigation; 